import { computed, ref } from 'vue';
import { doc, onSnapshot, query } from 'shared/services/firebase';

export default function useBetaPhaseManager(db, subscriptionManager) {
  const betaPhaseData = ref({ endOfBetaPhase: { seconds: 0 } });
  const retrieveData = () => {
    const q = query(doc(db, 'beta_phase', 'public'));
    const unsubscribe = onSnapshot(
      q,
      (querySnapShot) => {
        if (!querySnapShot.exists()) {
          return;
        }
        betaPhaseData.value = querySnapShot.data();
      },
    );
    subscriptionManager.addSubscriber(unsubscribe, { auth: false });
  };

  const isInBeta = computed(() => {
    const now = new Date();
    const betaEnd = new Date(betaPhaseData.value.endOfBetaPhase.seconds * 1000);
    return betaEnd - now > 0;
  });

  const endInDays = computed(() => {
    const now = new Date();
    const betaEnd = new Date(betaPhaseData.value.endOfBetaPhase.seconds * 1000);
    return Math.round((betaEnd - now) / (1000 * 60 * 60 * 24));
  });

  const showBetaPhaseCountDown = computed(() => betaPhaseData.value.showBetaPhaseCountDown);

  retrieveData();

  return {
    betaPhaseData,
    isInBeta,
    showBetaPhaseCountDown,
    endInDays,
  };
}
